module.exports = __webpack_public_path__ + "static/media/getPointEffect.13cf21b2.png";